import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import ProfileDropdown from '../components/ProfileDropdown';
import '../styles/newrecruiter.css';
import { getStoredUserForRole } from '../utils/authStorage';

const IcoHome = ({ active }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_home_analytics)">
      <path d="M9.99638 13.9949V8.6635C9.99638 8.48675 9.92617 8.31724 9.80119 8.19226C9.67621 8.06728 9.5067 7.99707 9.32995 7.99707H6.66423C6.48748 7.99707 6.31798 8.06728 6.193 8.19226C6.06802 8.31724 5.9978 8.48675 5.9978 8.6635V13.9949" stroke={active ? 'white' : '#26282B'} strokeWidth="1.33286" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1.99927 6.6641C1.99922 6.47021 2.04148 6.27865 2.12308 6.10278C2.20469 5.9269 2.32368 5.77095 2.47177 5.6458L7.13678 1.64788C7.37735 1.44456 7.68215 1.33301 7.99714 1.33301C8.31212 1.33301 8.61693 1.44456 8.8575 1.64788L13.5225 5.6458C13.6706 5.77095 13.7896 5.9269 13.8712 6.10278C13.9528 6.27865 13.9951 6.47021 13.995 6.6641V12.662C13.995 13.0155 13.8546 13.3545 13.6046 13.6044C13.3547 13.8544 13.0156 13.9948 12.6621 13.9948H3.33213C2.97863 13.9948 2.63961 13.8544 2.38965 13.6044C2.13969 13.3545 1.99927 13.0155 1.99927 12.662V6.6641Z" stroke={active ? 'white' : '#26282B'} strokeWidth="1.33286" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_home_analytics">
        <rect width="15.9943" height="15.9943" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const IcoCandidates = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="9" cy="7" r="4" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IcoQuestionBank = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 14.167H10.0083" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.4999 1.66699H4.99992C4.55789 1.66699 4.13397 1.84259 3.82141 2.15515C3.50885 2.46771 3.33325 2.89163 3.33325 3.33366V16.667C3.33325 17.109 3.50885 17.5329 3.82141 17.8455C4.13397 18.1581 4.55789 18.3337 4.99992 18.3337H14.9999C15.4419 18.3337 15.8659 18.1581 16.1784 17.8455C16.491 17.5329 16.6666 17.109 16.6666 16.667V5.83366L12.4999 1.66699Z" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.58325 7.49982C7.78323 6.94867 8.17056 6.48535 8.67753 6.19084C9.18449 5.89633 9.77884 5.78937 10.3567 5.88865C10.9345 5.98793 11.4591 6.28715 11.8387 6.73399C12.2182 7.18083 12.4287 7.74686 12.4333 8.33315C12.4333 9.99982 9.93325 10.8331 9.93325 10.8331" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoExamMgmt = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5001 1.66699H7.50008C7.03984 1.66699 6.66675 2.04009 6.66675 2.50033V4.16699C6.66675 4.62723 7.03984 5.00033 7.50008 5.00033H12.5001C12.9603 5.00033 13.3334 4.62723 13.3334 4.16699V2.50033C13.3334 2.04009 12.9603 1.66699 12.5001 1.66699Z" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3333 3.33301H14.9999C15.4419 3.33301 15.8659 3.5086 16.1784 3.82116C16.491 4.13372 16.6666 4.55765 16.6666 4.99967V16.6663C16.6666 17.1084 16.491 17.5323 16.1784 17.8449C15.8659 18.1574 15.4419 18.333 14.9999 18.333H4.99992C4.55789 18.333 4.13397 18.1574 3.82141 17.8449C3.50885 17.5323 3.33325 17.1084 3.33325 16.6663V4.99967C3.33325 4.55765 3.50885 4.13372 3.82141 3.82116C4.13397 3.5086 4.55789 3.33301 4.99992 3.33301H6.66659" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 9.16699H13.3333" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 13.333H13.3333" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.66675 9.16699H6.67508" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.66675 13.333H6.67508" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoAnalytics = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 2.5V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H17.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 14.1667V7.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.8333 14.167V4.16699" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.66675 14.167V11.667" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IcoSections = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M2.5 5H17.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round"/>
    <path d="M2.5 10H17.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round"/>
    <path d="M2.5 15H17.5" stroke={active ? 'white' : '#26282B'} strokeWidth="1.66667" strokeLinecap="round"/>
  </svg>
);

const IcoDrive = ({ active }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3.333 6.667h13.334M5 3.333h10c.92 0 1.667.746 1.667 1.667v10c0 .92-.746 1.667-1.667 1.667H5A1.667 1.667 0 0 1 3.333 15V5c0-.92.746-1.667 1.667-1.667Z" stroke={active ? 'white' : '#26282B'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M7 10h.01M10 10h3M7 13h.01M10 13h3" stroke={active ? 'white' : '#26282B'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
);

const SIDEBAR = [
  { label: 'Home', Icon: IcoHome, path: '/recruiter' },
  { label: 'Drives', Icon: IcoDrive, path: '/drives' },
  { label: 'Exam Management', Icon: IcoExamMgmt, path: '/exam-management' },
  { label: 'Candidates', Icon: IcoCandidates, path: '/candidates' },
  { label: 'Sections', Icon: IcoSections, path: '/sections' },
  { label: 'Question Bank', Icon: IcoQuestionBank, path: '/question-bank' },
  { label: 'Analytics', Icon: IcoAnalytics, path: '/analytics' },
];

export default function RecruiterAnalytics() {
  const navigate = useNavigate();
  const location = useLocation();
  const storedUser = getStoredUserForRole('recruiter');
  const [addCandidateHover, setAddCandidateHover] = useState(false);

  return (
    <div className="nr-page">
      <style>{`
        .ra-coming-wrap {
          min-height: calc(100vh - 180px);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ra-coming-card {
          width: min(100%, 720px);
          padding: 56px 40px;
          border-radius: 28px;
          background: linear-gradient(145deg, #ffffff 0%, #f7fbff 100%);
          border: 1px solid #dbe7f5;
          box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
          text-align: center;
        }
        .ra-coming-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 8px 16px;
          border-radius: 999px;
          background: #eef4ff;
          color: #2d6be4;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }
        .ra-coming-title {
          margin: 18px 0 12px;
          color: #1f2440;
          font-size: 42px;
          font-weight: 800;
          line-height: 1.1;
        }
        .ra-coming-text {
          margin: 0 auto;
          max-width: 520px;
          color: #64748b;
          font-size: 17px;
          line-height: 1.7;
        }
        .ra-coming-icon {
          width: 92px;
          height: 92px;
          margin: 0 auto 8px;
          border-radius: 24px;
          background: linear-gradient(180deg, #2d6be4 0%, #5b8def 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 18px 32px rgba(45, 107, 228, 0.22);
        }
        @media (max-width: 768px) {
          .ra-coming-card {
            padding: 40px 24px;
            border-radius: 22px;
          }
          .ra-coming-title {
            font-size: 34px;
          }
          .ra-coming-text {
            font-size: 15px;
          }
        }
      `}</style>

      <div className="nr-navbar-wrapper">
        <img src={logo} alt="Inteliment Logo" className="nr-navbar-logo-img" />
        <div className="nr-navbar-greeting">
          <h2 className="nr-navbar-greeting-title">Assessment Analytics</h2>
          <p className="nr-navbar-greeting-sub">Recruiter Dashboard</p>
        </div>
        <div className="nr-navbar-actions">
          <button
            className={`nr-navbar-add-btn ${addCandidateHover ? 'hovered' : ''}`}
            onMouseEnter={() => setAddCandidateHover(true)}
            onMouseLeave={() => setAddCandidateHover(false)}
            onClick={() => navigate('/candidates')}
          >
            <span className="nr-navbar-add-icon">+</span> Add Candidate
          </button>
          <div className="nr-navbar-profile">
            <ProfileDropdown user={storedUser.name || storedUser.email} email={storedUser.email} />
          </div>
        </div>
      </div>

      <aside className="nr-sidebar">
        {SIDEBAR
          .filter(item => !(storedUser.role === 'junior_recruiter' && item.path === '/question-bank'))
          .map(({ label, Icon, path }, index) => {
          const isActive = location.pathname === path;
          return (
            <div
              key={label}
              onClick={() => { if (path) navigate(path); }}
              className={`nr-sidebar-item ${isActive ? 'active' : ''}`}
              style={{ top: `${140 + index * 64}px` }}
            >
              <span className="nr-sidebar-icon"><Icon active={isActive} /></span>
              <span className="nr-sidebar-text">{label}</span>
            </div>
          );
        })}
      </aside>

      <main className="nr-main">
        <div className="ra-coming-wrap">
          <section className="ra-coming-card">
            <div className="ra-coming-icon">
              <svg width="42" height="42" viewBox="0 0 24 24" fill="none">
                <path d="M12 8V12L15 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="12" cy="12" r="8" stroke="white" strokeWidth="2" />
              </svg>
            </div>
            <span className="ra-coming-badge">Coming Soon</span>
            <h1 className="ra-coming-title">Analytics Page Is Coming Soon</h1>
            <p className="ra-coming-text">
        
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
